<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailposttugasDosen', query: { post: check.post, class: check.class } }"
                exact>
                <v-icon left>mdi-book</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailtugaskumpulDosen', query: { post: check.post, class: check.class } }"
                exact>
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon> Penilaian tugas
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0">
            <v-card
              flat>
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="4">
                    <h6 class="text-h6">List Jawaban Mahasiswa</h6>
                    <v-divider class="my-1"></v-divider>
                    <div v-if="detailansw.length > 0">
                      <div class="d-flex text-center">
                        <div class="d-inline px-3">
                          <span class="text-md-h4">
                            {{ sudahnilai }}
                          </span><br>
                          <span>Sudah dinilai</span>
                        </div>
                        <div class="d-inline">
                          <v-divider vertical></v-divider>
                        </div>
                        <div class="d-inline px-3">
                          <span class="text-md-h4">
                            {{ (detailansw.length - sudahnilai) }}
                          </span><br>
                          <span>Belum dinilai</span>
                        </div>
                      </div>
                      <!-- list -->
                      <v-list class="limit-height-scroll">
                        <v-list-item-group
                          v-model="listselect"
                          color="primary">
                          <v-list-item
                            v-for="(answ, i) in detailansw"
                            :key="i"
                            @click="selectAnsw(answ, i)"
                            class="style-border-btm">
                            <v-list-item-title class="py-3">
                              <div class="text-body-1">
                                {{ answ.user_firstname }} {{ answ.user_lastname }}<br>
                                <b>{{ answ.user_no }}</b>
                              </div>
                              <div class="caption">
                                at. {{ answ.post_at_answ }}
                              </div>
                              <v-chip
                                class="mr-1"
                                x-small
                                :color="answ.islate ? 'error' : 'success'">
                                {{ answ.islate ? 'Terlambat' : 'Tepat waktu' }}
                              </v-chip>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </div>
                    <div v-if="!detailansw.length">
                      <b class="caption">Tidak terdapat jawaban mahasiswa</b>
                    </div>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-card flat v-if="selectdata">
                          <v-app-bar flat color="transparent" dense>
                            <v-toolbar-title class="font-weight-bold primary--text">
                              {{ selectdata.user_firstname }} {{ selectdata.user_lastname }} - {{ selectdata.user_no }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-chip
                              small
                              :color="selectdata.islate ? 'error' : 'success'">
                              {{ selectdata.islate ? 'Terlambat' : 'Tepat waktu' }}
                            </v-chip>
                          </v-app-bar>
                          <v-card-text class="pt-0">
                            <div class="mb-md-10">
                              <div class="font-weight-bold">
                                Tanggal pengumpulan: {{ selectdata.post_at_answ }}
                              </div>
                              <v-chip
                                class="mt-1"
                                small
                                color="primary">
                                Nilai: {{ selectdata.grade_answ }} / 100
                              </v-chip>
                              <v-divider class="my-3"></v-divider>
                              <div class="black--text content-editor" v-html="selectdata.text_answ"></div>
                              <a
                                v-if="selectdata.file_answ"
                                :href="selectdata.urlanswer"
                                target="_blank">
                                View attachment file
                              </a>
                              <div v-if="selectdata.file_answ">
                                <iframe
                                  :src="getPdfView(selectdata.urlanswer)"
                                  style="width:100%; height:600px;"
                                  frameborder="0">
                                </iframe>
                              </div>
                            </div>
                            <div class="my-3">
                              <h6 class="text-h6 mb-1 black--text">Form Penilaian</h6>
                              <v-form
                                @submit.prevent="submitNilai"
                                ref="formsubmitnilai"
                                v-model="formadd.nilai"
                                lazy-validation>
                                <v-row justify="center" class="black--text">
                                  <v-col cols="12" md="12">
                                    <v-row>
                                      <v-col cols="12" md="12">
                                        <vue-editor
                                          v-model="selectdata.feedback_answ"
                                          placeholder="Feedback"
                                          :editorToolbar="customToolbar"
                                          class="custom-h-editor">
                                        </vue-editor>
                                      </v-col>
                                      <v-col cols="12" md="12">
                                        <v-text-field
                                          v-model="selectdata.grade_answ"
                                          :rules="[rules.required, rules.minnilai]"
                                          label="Nilai *"
                                          name="grade_answ"
                                          type="number">
                                        </v-text-field>
                                      </v-col>
                                      <v-col cols="12" md="12">
                                        <alertsp :alertdata="alertupdate"></alertsp>
                                        <v-btn
                                          large
                                          block
                                          :loading="loading.addnilai"
                                          :disabled="loading.addnilai || !formadd.nilai"
                                          :color="maincolor"
                                          class="white--text"
                                          type="submit">
                                          Simpan
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="12" md="12" class="text-center">
                                        <v-btn
                                          class="mr-2"
                                          outlined
                                          @click="nextSelect(selectidx, 0)"
                                          :disabled="selectidx <= 0">
                                          <v-icon>
                                            mdi-arrow-left-thick
                                          </v-icon>
                                        </v-btn>
                                        <v-btn
                                          class="mr-2"
                                          outlined
                                          @click="nextSelect(selectidx, 1)"
                                          :disabled="selectidx >= (detailansw.length - 1)">
                                          <v-icon>
                                            mdi-arrow-right-thick
                                          </v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-form>
                            </div>
                          </v-card-text>
                        </v-card>
                        <v-card flat v-if="!selectdata">
                          <v-card-text>
                            <b>Mohon pilih salah satu dari list jawaban mahasiswa!</b>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'DetailclassworkDosen', query: { class: check.class } }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Kembali ke kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getGdriveView } from '@/plugins/utils';
import { VueEditor } from 'vue2-editor';
import { mapState } from 'vuex';

export default {
  name: 'DetailtugaskumpulDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
      getansw: false,
      addnilai: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    detailansw: [],
    teacherlist: [],
    studentlist: [],
    listselect: 0,
    selectdata: null,
    selectidx: 0,
    sudahnilai: 0,
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
      post: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      nilai: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minnilai: (v) => (!!v && v <= 100) || 'Maksimum nilai 100',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'code-block'],
      ['clean'],
    ],
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
      }
    },
    '$route.query.post'(val) {
      if (val) {
        this.check.post = val;
        this.getPost();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
    }
    if (this.$route.query.post && this.$route.query.post !== '') {
      this.check.post = this.$route.query.post;
      this.getPost();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    isLate(ds1, ds2) {
      const d1 = Date.parse(ds1);
      const d2 = Date.parse(ds2);
      let late = false;
      if (d1 < d2) {
        late = true;
      }
      return late;
    },
    getPdfView(url) {
      return getGdriveView(url);
    },
    getPost() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class && this.check.post && this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/post/teacher/' + this.check.post + '/' + this.check.class,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.detaildata[0].urlmateri = this.api + '/upload/post/' + this.detaildata[0].file_post;
                this.getAnswer();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Data tidak ditemukan!';
      }
    },
    getAnswer() {
      this.loading.getansw = true;
      if (this.check.post && this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/answer/teacher/' + this.check.post,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const rd = res.data;
              // console.log(rd);
              if (rd.error === false) {
                this.detailansw = [];
                this.sudahnilai = 0;
                rd.data.forEach((element) => {
                  if (element.grade_at_answ) {
                    this.sudahnilai += 1;
                  }
                  element.urlanswer = this.api + '/upload/answer/' + element.file_answ;
                  element.islate = this.isLate(this.detaildata[0].duedate_post, element.post_at_answ);
                  this.detailansw.push(element);
                });
                // console.log(this.sudahnilai);
                this.selectdata = null;
                if (this.detailansw.length > this.selectidx) {
                  this.selectdata = this.detailansw[this.selectidx];
                  // this.selectidx = 0;
                } else {
                  this.selectdata = this.detailansw[0];
                }
                // console.log(this.detailansw);
              }
            }
            this.loading.getansw = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getansw = false;
          });
      }
    },
    nextSelect(idx, isnext) {
      let nidx = idx;
      if (isnext === 0) {
        nidx = idx - 1;
        this.selectdata = this.detailansw[nidx];
      } else {
        nidx = idx + 1;
        this.selectdata = this.detailansw[nidx];
      }
      this.listselect = nidx;
      this.selectidx = nidx;
    },
    selectAnsw(item, idx) {
      this.selectdata = item;
      this.selectidx = idx;
    },
    submitNilai() {
      this.alertupdate.show = false;
      if (this.$refs.formsubmitnilai.validate()) {
        if (this.tokenscr) {
          const datasend = {
            grade_answ: this.selectdata.grade_answ,
            feedback_answ: this.selectdata.feedback_answ,
            answer: this.selectdata.id_answ,
            post: this.selectdata.id_post,
          };
          this.loading.addnilai = true;
          this.axios
            .put(
              this.api + '/api/answer/teacher',
              qs.stringify(
                datasend,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Nilai berhasil diupdate!';
                  this.getAnswer();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addnilai = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.addnilai = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
